import { ValidationError } from 'yup';

import { i18n } from '@/i18n';

export function getValidationMessage(error: unknown, fallback = i18n.t('common.review_form_fields')) {
  if (error instanceof ValidationError) {
    return error.errors[0] || fallback;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
}
